






























import { Component, Vue, Prop } from "vue-property-decorator";
import { fieldTypesArray } from "./fieldTypes";
import { TableField } from "@/interfaces/generator";

@Component({
  components: {}
})
export default class EditFieldForm extends Vue {
  @Prop() field!: TableField;

  fieldTypes = fieldTypesArray;

  private get filteredDataArray() {
    return this.fieldTypes.filter(option => {
      return (
        option
          .toString()
          .toLowerCase()
          .indexOf(this.field.type.toLowerCase()) >= 0
      );
    });
  }
}
